import React, { useState } from 'react';

const PublicFormUserDetails = ({ user: initialUser, userFileName, onFileNameChange, onNext, onSkip }) => {
    const [user, setUser] = useState(initialUser || {
        name: '',
        email: ''
    });
    const [touched, setTouched] = useState({
        name: false,
        email: false
    });

    const isValid = () => {
        const emailRegex = /^[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[a-zA-Z.]{2,5}$/;

        return Boolean(user.name.trim()) && emailRegex.test(user.email.trim());
    };

    const updateUser = (field, value) => {
        setUser({
            ...user,
            [field]: value
        });
    };

    const setFieldTouched = (field) => {
        setTouched({
            ...touched,
            [field]: true
        });
    };

    const isNameInvalid = touched.name && !user.name.trim();
    const isEmailInvalid = touched.email && !/^[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[a-zA-Z.]{2,5}$/.test(user.email.trim());

    const handleSubmit = (e) => {
        e.preventDefault();
        if(isValid()) onNext(user, true);
    };

    return (
        <div className="flex-container no-margin with-gap column">
            <div className="">
                <h2 className="heading">User details</h2>
                <p className="sub-heading">Please share your name and email before continuing to the form.</p>
            </div>

            <form onSubmit={handleSubmit}>
                <div className="form-container">
                    <div className="form-group">
                        <label htmlFor="public-form-user-name">Name<span>*</span></label>
                        <input
                            id="public-form-user-name"
                            type="text"
                            className={`input-field${isNameInvalid ? ' error' : ''}`}
                            placeholder="Write down your name"
                            autoComplete="name"
                            value={user.name}
                            onChange={(e) => updateUser('name', e.target.value)}
                            onBlur={() => setFieldTouched('name')}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="public-form-user-email">Email<span>*</span></label>
                        <input
                            id="public-form-user-email"
                            type="email"
                            className={`input-field${isEmailInvalid ? ' error' : ''}`}
                            placeholder="Write down your email"
                            autoComplete="email"
                            value={user.email}
                            onChange={(e) => updateUser('email', e.target.value)}
                            onBlur={() => setFieldTouched('email')}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="public-form-file-name">File name (optional)</label>
                        <input
                            id="public-form-file-name"
                            type="text"
                            className="input-field"
                            placeholder="Enter a file name without the extension"
                            autoComplete="off"
                            value={userFileName}
                            onChange={(e) => onFileNameChange(e.target.value)}
                        />
                    </div>
                </div>

                <div className="footer button-holder">
                    <button className="btn" type="button" onClick={() => onSkip(false)}>Skip</button>
                    <button className="btn moral" type="submit" disabled={!isValid()}>Next</button>
                </div>
            </form>
        </div>
    );
};

export default PublicFormUserDetails;
